// extracted by mini-css-extract-plugin
module.exports = {"quizBlock":"QuizBlock_quizBlock__jL3jp","border":"QuizBlock_border__jlpYI","buttonWrapper":"QuizBlock_buttonWrapper__5JYOc","desktopWrapper":"QuizBlock_desktopWrapper__jLBmK"};